export const ENDPOINTS_ANNONCES = {
    GET_ALL: '/api/annonces',
    GET_ACTIVE: '/api/annonces/actives',
    GET_BY_ID: (id: number) => `/api/annonces/${id}`,
    CREATE_ANNONCE: '/api/annonces',
    UPDATE_ANNONCE: (id: number) => `/api/annonces/${id}`,
    DELETE_ANNONCE: (id: number) => `/api/annonces/${id}`,
    UPLOAD_IMAGE: (id: number) => `/api/annonces/${id}/upload-image`,
};
